import { PhoneNumber, PhoneNumberModel } from './phone-numbers.types';
import { mockPhoneNumbers } from './phone-numbers.mocks';
import { useQueryWithSetter } from '../helpers/useQueryWithSetter';

import MockSorage from '../helpers/mockStorage';
import { CustomAxios, getResponseData } from 'redux/axios';
import {
  PhoneNumberService,
  ListAvailableNumbersRequest,
  ListAvailableNumbersResponse,
  PurchaseNewPhoneNumberRequest,
  PurchaseNewPhoneNumberResponse,
} from '@weave/schema-gen-ts/dist/schemas/phone/number-service/v2/number_service.pb';

//Todo: Delete this whole folder I think
const mockStorage = new MockSorage<PhoneNumber>('PhoneNumbers', mockPhoneNumbers(), 'id');

const api = {
  listPhoneNumbers: (): Promise<PhoneNumber[]> => mockStorage.getAll(),
  getPhoneNumbers: (): Promise<PhoneNumberModel[]> =>
    CustomAxios.get(`desktop/v1/phones/sms/numbers`).then(getResponseData),
};

export function usePhoneNumberList(options?: any) {
  return useQueryWithSetter('phoneNumberList', api.listPhoneNumbers, options);
}

export const useQueryGetPhoneNumbers = () => {
  return useQueryWithSetter('getPhoneNumbers', api.getPhoneNumbers);
};

export const getAvailablePhoneNumbers = async (req: ListAvailableNumbersRequest) => {
  return await PhoneNumberService.ListAvailableNumbers(async (url) => {
    return getResponseData<ListAvailableNumbersResponse>(await CustomAxios.get(url));
  }, req);
};

export const purchasePhoneNumber = async (req: PurchaseNewPhoneNumberRequest) => {
  return await PhoneNumberService.PurchaseNewPhoneNumber(async (url) => {
    return getResponseData<PurchaseNewPhoneNumberResponse>(
      await CustomAxios.post(url, req)
    );
  }, req);
};

export default api;
